// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 7: BARUA NA UFUNUO
// ============================================================================
// Viwango 79-91 (viwango 13, maswali 39)

export const chapter7Translations = {
  name: "Barua na Ufunuo",
  description: "Yeye ashindaye ataurithi haya yote... Hekima ya juu hutakasa uelewa",
  
  spiritualWisdom: {
    principle: "Hekima ya juu hutakasa uelewa na kuhuisha roho",
    scripture: "Lakini kama mmoja wenu anakosa hekima, na amwombe Mungu (Yakobo 1:5)",
    application: "Kila barua ya mitume na kila maono ya Ufunuo hunufaisha uelewa wetu na kuimarisha tumaini letu"
  },
  
  levels: {
    79: {
      name: "Kukamatwa Yerusalemu",
      challenge: "Niko tayari si kufungwa tu, bali hata kufa Yerusalemu...",
      easy: {
        question: "Paulo alikamatwa wapi katika ziara yake ya mwisho?",
        options: ["Antiokia", "Efeso", "Yerusalemu", "Korintho"],
        correctAnswer: 2,
        hint: "Mji mtakatifu uliowatesa manabii mara nyingi",
        funFact: "🏛️ Yerusalemu: mahali pa utukufu na mateso kwa watumishi wote wa Mungu!"
      },
      medium: {
        question: "Wayahudi walimshtaki Paulo kwa nini?",
        options: [
          "Kuiba kutoka Hekaluni",
          "Kunajisi Hekalu kwa kuwaleta watu wa Mataifa",
          "Kumkufuru Musa",
          "Kuasi dhidi ya Rumi"
        ],
        correctAnswer: 1,
        hint: "Shutuma linalohusiana na ujumla wa Injili",
        funFact: "⛪ Kejeli: Paulo alishtakiwa kunajisi Hekalu aliloliheshimu sana!"
      },
      hard: {
        question: "Paulo alibadilisha jela lake kuwa fursa vipi?",
        options: [
          "Alikimbia",
          "Alishuhudia mbele ya mamlaka na kuandika barua zake",
          "Alikaa kimya",
          "Alijadili kuachiwa huru"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu kubadilisha majaribu kuwa ushuhuda",
        funFact: "⛓️ Minyororo ya kimwili, uhuru wa kiroho - ushuhuda wenye nguvu wa imani!"
      }
    },
    
    80: {
      name: "Mbele ya Gavana Feliki",
      challenge: "Alipozungumza kuhusu haki, kujizuia na hukumu ijayo...",
      easy: {
        question: "Paulo alishuhudia imani yake mbele ya gavana yupi?",
        options: ["Pilato", "Feliki", "Festo", "Galio"],
        correctAnswer: 1,
        hint: "Gavana aliyejulikana kwa tamaa yake",
        funFact: "⚖️ Feliki alitumaini hongo - ufisadi mbele ya uadilifu!"
      },
      medium: {
        question: "Feliki alireaktiaje kwa ujumbe wa Paulo?",
        options: [
          "Alitubu",
          "Aliogopa na kutetemeka",
          "Alidhihaki",
          "Hakujali"
        ],
        correctAnswer: 1,
        hint: "Dhamiri lililosumbuliwa na ukweli",
        funFact: "😰 Hata waliooza wanatikisika mbele ya ukweli wa Mungu - dhamiri ya ulimwengu!"
      },
      hard: {
        question: "Kwa nini Feliki alimweka Paulo gerezani miaka miwili?",
        options: [
          "Kumlinda",
          "Kwa maslahi ya kisiasa na matumaini ya ufisadi",
          "Alisahau",
          "Kwa imani"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu hesabu za kisiasa na za kibinafsi",
        funFact: "🏛️ Haki ya binadamu iliyooza vs haki kamili ya Mungu - tofauti kubwa!"
      }
    },

    81: {
      name: "Rufaa kwa Kaisari",
      challenge: "Naomba niende mbele ya Kaisari!",
      easy: {
        question: "Paulo alitumia haki gani kuepuka kusikilizwa Yerusalemu?",
        options: [
          "Haki ya kimbilio",
          "Rufaa kwa Kaisari (raia wa Rumi)",
          "Haki ya kukimbia",
          "Ulinzi wa kidiplomasia"
        ],
        correctAnswer: 1,
        hint: "Faida za uraia wake wa Rumi",
        funFact: "🏛️ Uraia wa Rumi: pasi ya kimungu ya kupeleka Injili Rumi!"
      },
      medium: {
        question: "Paulo alishuhudia mbele ya nani kabla ya kuondoka?",
        options: [
          "Sanhedrini",
          "Mfalme Agripa na Berenike",
          "Askari wa Kirumi",
          "Umati wa Wayahudi"
        ],
        correctAnswer: 1,
        hint: "Ufalme wa Herode ulioingizwa Kiyahudi",
        funFact: "👑 Kutoka kwa mchungaji wa kondoo hadi jumba la kifalme - kupandishwa kwa kimungu kwa Paulo!"
      },
      hard: {
        question: "Mungu anatumia vipi mifumo ya kibinadamu kwa mipango yake?",
        options: [
          "Anayapuuza",
          "Anayatumia kwa uangalizi kutekeleza makusudi yake",
          "Anayaharibu",
          "Anapinga kila wakati"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu utawala wa Mungu juu ya historia",
        funFact: "🌐 Haki ya Rumi inakuwa chombo cha Injili - uangalizi wa ajabu!"
      }
    },

    82: {
      name: "Kuvunjika kwa Meli Malta",
      challenge: "Usiogope, Paulo; ni lazima usimame mbele ya Kaisari...",
      easy: {
        question: "Paulo alivunjika kwa meli kwenye kisiwa gani?",
        options: ["Krete", "Kipro", "Malta", "Sisilia"],
        correctAnswer: 2,
        hint: "Kisiwa kidogo kusini mwa Sisilia",
        funFact: "🏝️ Malta: kusimama kwa lazima kunakuwa ujumbe wenye matunda - njia za Mungu!"
      },
      medium: {
        question: "Paulo alifanya miujiza gani Malta?",
        options: [
          "Alituliza dhoruba",
          "Aliponya baba wa Publio na wagonjwa wengine",
          "Alizidisha chakula",
          "Alihuisha maiti"
        ],
        correctAnswer: 1,
        hint: "Uponyaji mwingi kwenye kisiwa",
        funFact: "🏥 Paulo: kutoka kwa aliyevunjika na meli hadi daktari wa miujiza - sifa ya kimungu!"
      },
      hard: {
        question: "Kuvunjika huku kwa meli kunaonyeshaje uaminifu wa Mungu?",
        options: [
          "Ajali hutokea",
          "Mungu analinda na kutimiza ahadi zake ijapokuwa kuna vizuizi",
          "Paulo alikuwa na bahati",
          "Ingeweza kuepukwa"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu uaminifu wa Mungu kwa ahadi",
        funFact: "⛈️ Dhoruba, kuvunjika kwa meli, nyoka: hakuna kinachoweza kuzuia mpango wa Mungu kwa Paulo!"
      }
    },

    83: {
      name: "Paulo Rumi",
      challenge: "Alikaa miaka miwili kamili katika nyumba aliyoipanga...",
      easy: {
        question: "Paulo aliishi katika hali gani Rumi?",
        options: [
          "Katika gereza lililo fungwa",
          "Chini ya kifungo cha nyumbani",
          "Katika uhuru kamili",
          "Uhamishoni"
        ],
        correctAnswer: 1,
        hint: "Uhuru wa kiasi chini ya ulinzi",
        funFact: "🏠 Nyumba-gereza inakuwa kituo cha ujumbe - uhuru katika minyororo!"
      },
      medium: {
        question: "Paulo alifanya nini katika miaka miwili yake Rumi?",
        options: [
          "Alipumzika",
          "Alifundisha na kuandika barua zake",
          "Alijiandaa kwa utetezi wake",
          "Alitembelea"
        ],
        correctAnswer: 1,
        hint: "Huduma kali ijapokuwa ana minyororo",
        funFact: "✍️ Barua za gerezani: Waefeso, Wafilipi, Wakolosai, Filemoni!"
      },
      hard: {
        question: "Paulo aliishije huduma yake kulingana na mapokeo?",
        options: [
          "Alikufa kwa ugonjwa",
          "Alikatwa kichwa chini ya Nero karibu mwaka 67 BK",
          "Alikufa kwa uzee",
          "Alitoweka kwa siri"
        ],
        correctAnswer: 1,
        hint: "Ushahidi chini ya mfalme mwendawazimu",
        funFact: "⚔️ 'Nimepigana vita vizuri, nimemaliza mbio' - ushindi wa mwisho!"
      }
    },

    84: {
      name: "Waraka kwa Warumi",
      challenge: "Sioni aibu kwa Injili; ni nguvu ya Mungu kwa wokovu...",
      easy: {
        question: "Waraka upi unaendeleza zaidi mafundisho ya wokovu kwa imani?",
        options: ["1 Wakorintho", "Wagalatia", "Warumi", "Waefeso"],
        correctAnswer: 2,
        hint: "'Kanisa kuu' la kitheolojia la Paulo",
        funFact: "🏛️ Warumi: kazi bora ya kitheolojia iliyomgeuza Agustino na Luther!"
      },
      medium: {
        question: "Kulingana na Warumi, mtu anafanywa haki vipi mbele za Mungu?",
        options: [
          "Kwa matendo mazuri",
          "Kwa imani pekee, bila matendo",
          "Kwa dhabihu",
          "Kwa jadi"
        ],
        correctAnswer: 1,
        hint: "Kanuni ya msingi ya Mageuzi",
        funFact: "⚖️ 'Mwenye haki ataishi kwa imani' - mapinduzi ya kiroho ya Paulo!"
      },
      hard: {
        question: "Upeo gani wa ulimwengu una waraka huu?",
        options: [
          "Unahusu Warumi tu",
          "Unaeleza mpango wa wokovu kwa wanadamu wote",
          "Unakosoa Rumi tu",
          "Umepitwa na wakati"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu mpango wa ulimwengu wa wokovu",
        funFact: "🌍 Injili = nguvu ya Mungu kwa wote: Wayahudi na Wagiriki - ujumla kamili!"
      }
    },

    85: {
      name: "Wimbo wa Upendo - 1 Wakorintho 13",
      challenge: "Nijapokuwa ninazungumza lugha za wanadamu na malaika, lakini sina upendo...",
      easy: {
        question: "Sura ipi ya Biblia inaitwa 'wimbo wa upendo'?",
        options: [
          "1 Wakorintho 12",
          "1 Wakorintho 13",
          "1 Yohana 4",
          "Warumi 8"
        ],
        correctAnswer: 1,
        hint: "Sura ya kati ya 1 Wakorintho",
        funFact: "💝 Sura inayosomwa zaidi katika harusi - ufafanuzi kamili wa upendo!"
      },
      medium: {
        question: "Paulo anasema nini kuhusu kudumu kwa upendo?",
        options: [
          "Upendo hupita kwa wakati",
          "Upendo haushindwi kamwe",
          "Upendo unategemea hali",
          "Upendo ni wa muda"
        ],
        correctAnswer: 1,
        hint: "Umilele wa upendo wa Mungu",
        funFact: "♾️ Upendo pekee unavuka mauti na umilele - thamani ya juu zaidi!"
      },
      hard: {
        question: "Kwa nini Paulo anaweka upendo juu ya vipawa vya kiroho?",
        options: [
          "Vipawa ni vibaya",
          "Upendo unatoa maana na thamani kwa kila kitu kingine",
          "Upendo ni rahisi zaidi",
          "Vipawa vinagawanya"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu injini na maana ya huduma yote",
        funFact: "🎯 Bila upendo, hata vipawa vikuu vinakuwa kelele na kiburi!"
      }
    },

    86: {
      name: "Waefeso: Kanisa Mwili wa Kristo",
      challenge: "Alivitia vitu vyote chini ya miguu yake, na kumweka kuwa kichwa cha Kanisa...",
      easy: {
        question: "Kulingana na Waefeso, Kanisa ni nini kwa Kristo?",
        options: [
          "Hekalu lake",
          "Mwili wake",
          "Familia yake",
          "Jeshi lake"
        ],
        correctAnswer: 1,
        hint: "Mfano wa kikaboni wa umoja",
        funFact: "👤 Mwili wa Kristo: kila Mkristo ni kiungo muhimu - kutegemana kwa pamoja!"
      },
      medium: {
        question: "Paulo anaeleza silaha gani kwa vita vya kiroho?",
        options: [
          "Silaha za kimwili",
          "Silaha za Mungu: kweli, haki, amani, imani, wokovu, Neno",
          "Silaha za Kirumi",
          "Ulinzi wa kichawi"
        ],
        correctAnswer: 1,
        hint: "Vipande sita vya silaha za kiroho",
        funFact: "⚔️ Vita vya kiroho kwa silaha za kiroho - mkakati wa Mungu wa ushindi!"
      },
      hard: {
        question: "Mapambano yetu ya kweli ni dhidi ya nani kulingana na Paulo?",
        options: [
          "Dhidi ya watu wabaya",
          "Dhidi ya nguvu za kiroho za uovu",
          "Dhidi ya serikali",
          "Dhidi ya umaskini"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu nguvu za kiroho zisizoonekana",
        funFact: "👹 Vita vya kosmiki: nyuma ya migogoro ya kibinadamu, kuna vita halisi ya kiroho!"
      }
    },

    87: {
      name: "Wafilipi: Furaha katika Majaribu",
      challenge: "Furahini daima katika Bwana; tena nasema, furahini!",
      easy: {
        question: "Hisia gani Paulo anahamasisha ijapokuwa yuko gerezani?",
        options: ["Kukata tamaa", "Furaha", "Hasira", "Huzuni"],
        correctAnswer: 1,
        hint: "Hisia ya kushangaza kwa mfungwa",
        funFact: "😊 Furaha mara 16 katika sura 4 - rekodi ya furaha gerezani!"
      },
      medium: {
        question: "Kulingana na Wafilipi 2, Yesu alichukua msimamo gani?",
        options: [
          "Alijilazimisha kwa nguvu",
          "Alijidhili na kujinyenyekeza hadi kufa",
          "Alikimbia wajibu",
          "Alitafuta utukufu"
        ],
        correctAnswer: 1,
        hint: "Mwendo wa kujinyenyekeza kwa hiari",
        funFact: "📉 Yesu: kutoka usawa na Mungu hadi kifo msalabani - upendo wa kupindukia!"
      },
      hard: {
        question: "Paulo anawezaje kuhubiri furaha gerezani?",
        options: [
          "Anajifanya",
          "Furaha ya Kikristo inazidi hali",
          "Ni mtu wa masokista",
          "Anakataa ukweli"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu furaha ya ajabu",
        funFact: "✨ Furaha = tunda la Roho bila kujali hali - siri ya Mungu!"
      }
    },

    88: {
      name: "Barua za Kichungaji",
      challenge: "Pambana vita vizuri vya imani, kamata uzima wa milele...",
      easy: {
        question: "Paulo aliandikia nani barua zake za mwisho za kichungaji?",
        options: [
          "Wakorintho",
          "Timotheo na Tito",
          "Warumi",
          "Wagalatia"
        ],
        correctAnswer: 1,
        hint: "Wanawe wa kiroho na washirika",
        funFact: "👨‍👦 Wosia wa kiroho: Paulo anapitisha mwenge kwa kizazi kifuatacho!"
      },
      medium: {
        question: "Paulo anatoa ushauri gani wa kuchagua viongozi wa kanisa?",
        options: [
          "Chagua matajiri zaidi",
          "Chagua kulingana na vigezo vikali vya maadili na kiroho",
          "Chagua wenye elimu zaidi",
          "Chagua maarufu zaidi"
        ],
        correctAnswer: 1,
        hint: "Sifa za kimaadili kwanza",
        funFact: "⚖️ Viwango vya juu kwa viongozi: tabia kabla ya uwezo - vipaumbele vya Mungu!"
      },
      hard: {
        question: "Urithi gani Paulo anamwachia Timotheo?",
        options: [
          "Mali za kimwili",
          "Uaminifu kwa Injili na huduma ya kichungaji",
          "Nafasi ya kisiasa",
          "Shule ya utheolojia"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu urithi wa kiroho",
        funFact: "📜 'Linda amana nzuri' - kupitisha kwa uaminifu Injili kwa karne nyingi!"
      }
    },

    89: {
      name: "Waebrania: Yesu Kuhani Mkuu",
      challenge: "Tunaye Kuhani Mkuu aliyepita mbingu...",
      easy: {
        question: "Kulingana na Waebrania, nani Kuhani wetu Mkuu?",
        options: ["Haruni", "Musa", "Yesu", "Melkisedeki"],
        correctAnswer: 2,
        hint: "Mpatanishi kamili kati ya Mungu na wanadamu",
        funFact: "✝️ Yesu: Kuhani na Dhabihu - dhabihu kamili mara moja milele!"
      },
      medium: {
        question: "Kwa nini ukuhani wa Yesu ni mkuu kuliko wa Haruni?",
        options: [
          "Ni wa zamani zaidi",
          "Ni wa milele kulingana na utaratibu wa Melkisedeki",
          "Ni tajiri zaidi",
          "Ni maarufu zaidi"
        ],
        correctAnswer: 1,
        hint: "Umilele dhidi ya muda",
        funFact: "♾️ Ukuhani wa milele: Yesu anaombea milele kwa ajili yetu!"
      },
      hard: {
        question: "Waebrania inaonyeshaje Agano Jipya?",
        options: [
          "Sawa na la zamani",
          "Bora na la mwisho, limeandikwa mioyoni",
          "La muda",
          "La hiari"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu kutimizwa na kuzidia",
        funFact: "📋 Agano Jipya: sheria iliyoandikwa mioyoni, si kwenye jiwe!"
      }
    },

    90: {
      name: "Yakobo: Imani na Matendo",
      challenge: "Imani bila matendo ni maiti...",
      easy: {
        question: "Kulingana na Yakobo, nini kinapaswa kuambatana na imani?",
        options: [
          "Maneno",
          "Matendo",
          "Hisia",
          "Maarifa"
        ],
        correctAnswer: 1,
        hint: "Onyesho la vitendo la imani",
        funFact: "🌳 Imani = mizizi, matendo = matunda - mti kamili wa kiroho!"
      },
      medium: {
        question: "Yakobo analinganisha ulimi na nini?",
        options: [
          "Upanga",
          "Moto mdogo uwakao msitu mkubwa",
          "Ala ya muziki",
          "Zana"
        ],
        correctAnswer: 1,
        hint: "Kiungo kidogo lakini nguvu kubwa ya uharibifu",
        funFact: "🔥 Ulimi: kiungo kidogo lakini kinaweza kuchoma maisha yote - angalizo!"
      },
      hard: {
        question: "Tunapatanishaje Yakobo na Paulo kuhusu imani/matendo?",
        options: [
          "Wanapingana",
          "Paulo anazungumza kuhusu kuhesabiwa haki, Yakobo kuhusu utakaso",
          "Mmoja anakosea",
          "Hakuna suluhisho"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu vipengele viwili vinavyojumuisha",
        funFact: "⚖️ Paulo: okoka kwa imani / Yakobo: imani inayothibitishwa kwa matendo - mwafaka kamili!"
      }
    },

    91: {
      name: "Ufunuo: Kurudi kwa Mfalme",
      challenge: "Tazama, ninakuja hivi karibuni. Heri yeye alindaye maneno ya unabii wa kitabu hiki!",
      easy: {
        question: "Yakobo anaandikia makanisa mangapi katika Ufunuo?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "Nambari ya ukamilifu",
        funFact: "⛪ Makanisa 7 ya Asia: kioo cha makanisa yote ya nyakati zote!"
      },
      medium: {
        question: "Historia inaishiaje kulingana na Ufunuo?",
        options: [
          "Uharibifu kamili",
          "Mbingu mpya na dunia mpya",
          "Kurudi kwa bustani ya dunia",
          "Mwisho wa uwepo wote"
        ],
        correctAnswer: 1,
        hint: "Kufanywa upya kamili kwa uumbaji",
        funFact: "🌅 Si mwisho wa dunia bali kufanywa upya kamili - tumaini la mwisho!"
      },
      hard: {
        question: "Ujumbe gani wa kati Ufunuo unawasilisha kwa wanaoteswa?",
        options: [
          "Jisalimisheni",
          "Kristo anatawala na atashinda mwishoni",
          "Kimbieni kutoka mateso",
          "Jilipizeni kisasi"
        ],
        correctAnswer: 1,
        hint: "Inakuhusu tumaini la ushindi wa mwisho",
        funFact: "👑 'Aliyekuwepo, aliyeko, na atakayekuja' - Bwana wa historia na wakati!"
      }
    }
  }
};

export default chapter7Translations;
